// Service-worker updates. The app must never reload itself mid-consultation, so
// a new build shows a banner and the user chooses when to apply it. Devices left
// open all day also poll, otherwise a clinic could sit on an old build for weeks.
import { registerSW } from 'virtual:pwa-register';

const CHECK_EVERY_MS = 30 * 60 * 1000;

let applyUpdate: ((reload?: boolean) => Promise<void>) | null = null;
const listeners = new Set<(ready: boolean) => void>();

export function onUpdateReady(fn: (ready: boolean) => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function applyPendingUpdate(): void {
  void applyUpdate?.(true);
}

export function startUpdateWatch(): void {
  applyUpdate = registerSW({
    immediate: true,
    onNeedRefresh() { listeners.forEach((fn) => fn(true)); },
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      setInterval(() => {
        if (navigator.onLine) void registration.update().catch(() => undefined);
      }, CHECK_EVERY_MS);
    },
  });
}
